export default __webpack_public_path__ + "static/media/nassau.5348d5c9.jpeg";